export default __webpack_public_path__ + "static/media/Ellipse 197.6a9eca84.svg";